// NGRX
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { AgreementActions, AgreementActionTypes } from '../_actions/agreement.actions';
// Models
import { Agreement } from '../_models/agreement.model';
import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';

export interface AgreementsState extends EntityState<Agreement> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: any;
  lastCreatedAgreementId: number;
  lastQuery: QueryParamsModel;
  error: any | null;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;

  isAllAgreementsLoaded: boolean;
  queryRowsCount: number;
  queryResult: Agreement[];
  allAgreements: Agreement[];
}

export const adapter: EntityAdapter<Agreement> = createEntityAdapter<Agreement>();

export const initialAgreementsState: AgreementsState = adapter.getInitialState({
  isAllAgreementsLoaded: false,
  queryRowsCount: 0,
  queryResult: [],
  lastCreatedAgreementId: undefined,
  totalCount: 0,
  listLoading: false,
  actionsloading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  allAgreements: [],
  error: null,
  latestSuccessfullAction: null,
});

export function agreementsReducer(
  state = initialAgreementsState,
  action: AgreementActions,
): AgreementsState {
  switch (action.type) {
    case AgreementActionTypes.AgreementsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedAgreementId: undefined,
      };
    case AgreementActionTypes.AgreementsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case AgreementActionTypes.AgreementOnServerCreated:
      return {
        ...state,
      };
    case AgreementActionTypes.AgreementOnServerUpdated:
      return {
        ...state,
      };
    case AgreementActionTypes.AgreementOnServerDeleted:
      return {
        ...state,
      };
    case AgreementActionTypes.AgreementsOnServerDeleted:
      return {
        ...state,
      };
    case AgreementActionTypes.AgreementCreated:
      return adapter.addOne(action.payload.agreement, {
        ...state,
        lastCreatedAgreementId: action.payload.agreement.id,
      });
    case AgreementActionTypes.AgreementUpdated:
      return adapter.updateOne(action.payload.partialagreement, state);
    case AgreementActionTypes.AgreementDeleted:
      return adapter.removeOne(action.payload.id, state);
    case AgreementActionTypes.AgreementsDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case AgreementActionTypes.AllAgreementsLoaded:
      return {
        ...state,
        allAgreements: action.payload.agreements,
      };
    case AgreementActionTypes.AgreementsPageCancelled:
      return {
        ...state,
        listLoading: false,
        showInitWaitingMessage: false,
        queryRowsCount: 0,
        queryResult: [],
        lastQuery: new QueryParamsModel({}),
      };
    case AgreementActionTypes.AgreementsPageLoaded:
      return adapter.addMany(action.payload.agreements, {
        ...initialAgreementsState,
        listLoading: false,
        allAgreements: state.allAgreements,
        queryResult: action.payload.agreements,
        showInitWaitingMessage: false,
        totalCount: action.payload.totalCount,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    case AgreementActionTypes.ThrowAgreementError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case AgreementActionTypes.FireAgreementSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
